import { register } from '../modules/sections.js'
import Section from '../modules/section.js'
import { on } from '../modules/events.js'

class ContactsSection extends Section {
  init() {
    on(this.refs.form, 'submit', (e) => {
      e.preventDefault()
      grecaptcha.ready(() => {
        grecaptcha.execute(window.__recaptchaSiteKey, { action: 'submit' }).then((token) => {
          this.refs.token.value = token
          this.refs.form.submit()
        });
      })
    })

    on(this.refs.fileInput, 'change', () => {
      if(this.refs.fileInput.files.length > 3) {
        alert(this.refs.fileInput.dataset.maxError)
        this.refs.fileInput.value = ''
      }
      else {
        for (const file of this.refs.fileInput.files) {
          if (file.size > 10000000) {
            alert(this.refs.fileInput.dataset.sizeError)
            this.refs.fileInput.value = ''
          }
        }
      }
    })
  }
}

register('contacts', ContactsSection)
